import { combineReducers } from 'redux';

import loadMonitoringDashboardUiReducer from './loadMonitoringDashboardUiReducer';
import loadMonitoringDashboardDataReducer from './loadMonitoringDashboardDataReducer';

export default combineReducers({
  ui: loadMonitoringDashboardUiReducer,
  data: loadMonitoringDashboardDataReducer,
});
